import { isDesktop, isIOS, isAndroid, deviceDetect } from 'react-device-detect';
import { Source } from '../booking/createBooking';

type DeviceInfo = {
  browserFullVersion: string;
  browserMajorVersion: string;
  browserName: string;
  engineName: string;
  engineVersion: string;
  isBrowser: boolean;
  osName: string;
  osVersion: string;
  userAgent: string;
};
export const getSource = (): Source => {
  if (isDesktop) return 'WEB';
  if (isIOS) return 'IOS_WEB';
  if (isAndroid) return 'ANDROID_WEB';

  return 'OTHER';
};

export const getDeviceInfo = (): DeviceInfo => {
  return deviceDetect(navigator.userAgent);
};
